/* Own header search (2026-10-23) - replaces the Searchanise overlay on the two header search boxes.
   - Finds products by name AND by SKU (also SKUs that contain spaces, e.g. "VS 2301-Gold Grey"). Shopify's own search does
     the work (/search/suggest.json): a normal query for names/tags/collections plus, when the text looks like a SKU, an exact
     "quoted" query on variants.sku. Pressing Enter on an exact SKU goes straight to that product.
   - Nothing is loaded until the visitor touches a search box (then the small stylesheet is added), so it costs the page nothing.
   - Built to be light for INP: one delegated listener, debounced typing, one panel reused for every search, no layout reads
     while typing. Customer text is only ever inserted as text (never as HTML).
   Config comes from window.htSearch (layout/theme.liquid): { searchUrl, popular: [{t, u}], css } */
(function () {
  'use strict';
  var cfg = window.htSearch || {};
  var SEARCH_URL = cfg.searchUrl || '/search';
  var POPULAR = cfg.popular || [];
  var TREND = cfg.trending || '', trend = null, trendP = null;
  var SEL = '.header__inline-search-input, .header-search__input';
  var KEY = 'ht_recent_searches';
  var cache = {}, ctl = null, timer = null;
  var input = null, panel = null, body = null, announce = null, items = [], active = -1, term = '', model = null, cssLoaded = false;

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function enc(s) { return encodeURIComponent(s); }
  function money(v) { var n = Math.round(Number(v)); return isNaN(n) ? '' : '₹' + n.toLocaleString('en-IN'); }
  function skuLike(t) { return t.length >= 4 && /\d/.test(t) && /[a-z]/i.test(t); }
  function recent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]').slice(0, 5); } catch (e) { return []; } }
  function remember(t) { t = t.trim(); if (!t) return; try { var r = recent().filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); }); r.unshift(t); localStorage.setItem(KEY, JSON.stringify(r.slice(0, 5))); } catch (e) { } }
  function forget() { try { localStorage.removeItem(KEY); } catch (e) { } }
  function productUrl(p) { return '/products/' + p.handle; }
  function sized(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function loadCss() {
    if (cssLoaded || !cfg.css) return; cssLoaded = true;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = cfg.css; document.head.appendChild(l);
  }

  /* ---------- panel ---------- */
  function ensurePanel() {
    if (panel) return;
    panel = el('div', 'ht-sr'); panel.id = 'ht-sr'; panel.hidden = true;
    body = el('div', 'ht-sr__body'); body.setAttribute('role', 'listbox'); body.setAttribute('aria-label', 'Search suggestions');
    announce = el('p', 'ht-sr__live'); announce.setAttribute('aria-live', 'polite'); announce.setAttribute('role', 'status');
    panel.appendChild(body); panel.appendChild(announce); document.body.appendChild(panel);
    panel.addEventListener('pointerdown', function (e) { e.preventDefault(); });     // keep the focus in the box while tapping a result
    panel.addEventListener('click', function (e) {
      var c = e.target.closest('[data-ht-recent]'); if (c) { input.value = c.getAttribute('data-ht-recent'); run(true); input.focus(); return; }
      if (e.target.closest('[data-ht-clear]')) { forget(); showIdle(); return; }
      var a = e.target.closest('a[href]'); if (a && term) remember(term);
    });
  }
  function position() {
    if (!input || !panel) return;
    var r = (input.closest('form') || input).getBoundingClientRect(), vw = document.documentElement.clientWidth, small = vw < 750;
    var width = small ? vw - 20 : Math.min(860, vw - 28), left = small ? 10 : Math.min(Math.max(14, r.left - 4), vw - width - 14);
    panel.classList.toggle('ht-sr--wide', width >= 680);
    var top = Math.round(r.bottom + 8);
    panel.style.cssText = 'left:' + Math.round(left) + 'px;top:' + top + 'px;width:' + Math.round(width) + 'px;max-height:' + Math.max(240, window.innerHeight - top - 12) + 'px';
  }
  function open() { ensurePanel(); position(); panel.hidden = false; setTimeout(position, 120); setTimeout(position, 400);   /* the header may still be settling */ input.setAttribute('aria-expanded', 'true'); }
  function close() { if (!panel || panel.hidden) return; panel.hidden = true; active = -1; if (input) { input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); } }

  function setActive(i) {
    if (active > -1 && items[active]) items[active].classList.remove('is-active');
    active = items.length ? (i + items.length) % items.length : -1;
    if (active > -1) { var it = items[active]; it.classList.add('is-active'); input.setAttribute('aria-activedescendant', it.id); it.scrollIntoView({ block: 'nearest' }); }
    else input.removeAttribute('aria-activedescendant');
  }
  function collect() { items = Array.prototype.slice.call(body.querySelectorAll('a.ht-sr__item, a.ht-sr__card, a.ht-sr__all')); items.forEach(function (a, i) { a.id = 'ht-sr-' + i; a.setAttribute('role', 'option'); }); active = -1; }

  /* ---------- views ---------- */
  function chip(text, href, recentTerm) {
    var a = el(href ? 'a' : 'button', 'ht-sr__chip', text);
    if (href) a.href = href; else { a.type = 'button'; a.setAttribute('data-ht-recent', recentTerm); }
    return a;
  }
  function showIdle() {
    ensurePanel(); open(); body.textContent = ''; body.className = 'ht-sr__body is-idle'; term = ''; model = null;
    var r = recent();
    if (r.length) {
      var s = el('section', 'ht-sr__sec'); var h = el('div', 'ht-sr__head'); h.appendChild(el('span', '', 'Recent searches'));
      var c = el('button', 'ht-sr__clear', 'Clear'); c.type = 'button'; c.setAttribute('data-ht-clear', ''); h.appendChild(c); s.appendChild(h);
      var w = el('div', 'ht-sr__chips'); r.forEach(function (t) { w.appendChild(chip(t, null, t)); }); s.appendChild(w); body.appendChild(s);
    }
    if (POPULAR.length) {
      var s2 = el('section', 'ht-sr__sec'); s2.appendChild(el('div', 'ht-sr__head', 'Shop by category'));
      var w2 = el('div', 'ht-sr__chips ht-sr__chips--cats'); POPULAR.forEach(function (p) { w2.appendChild(chip(p.t, p.u)); }); s2.appendChild(w2); body.appendChild(s2);
    }
    if (TREND) {
      var s3 = el('section', 'ht-sr__sec ht-sr__sec--trend'); s3.appendChild(el('div', 'ht-sr__head', 'Trending now'));
      var grid = el('div', 'ht-sr__grid'); s3.appendChild(grid); body.appendChild(s3);
      if (trend) fillTrend(grid, trend);
      else {
        for (var k = 0; k < 6; k++) { var sk = el('span', 'ht-sr__card ht-sr__card--sk'); sk.appendChild(el('span', 'ht-sr__cimg')); grid.appendChild(sk); }
        loadTrend().then(function (list) { if (grid.isConnected && !model) { fillTrend(grid, list); collect(); } }, function () { if (grid.isConnected) s3.remove(); });
      }
    }
    if (!body.firstChild) { close(); return; }
    collect(); announce.textContent = '';
    position();
  }
  /* best sellers for the empty search box: one small request to the collection feed, remembered for the visit */
  function loadTrend() {
    if (trendP) return trendP;
    try { var c = sessionStorage.getItem('ht_trend'); if (c) { trend = JSON.parse(c); return (trendP = Promise.resolve(trend)); } } catch (e) { }
    trendP = fetch('/collections/' + TREND + '/products.json?limit=6', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('trend ' + r.status); return r.json(); })
      .then(function (d) {
        trend = (d.products || []).slice(0, 6).map(function (p) {
          var v = p.variants && p.variants[0] || {};
          return { handle: p.handle, title: p.title, img: p.images && p.images[0] && p.images[0].src, price: v.price, was: v.compare_at_price };
        });
        try { sessionStorage.setItem('ht_trend', JSON.stringify(trend)); } catch (e) { }
        return trend;
      });
    trendP.catch(function () { trendP = null; });
    return trendP;
  }
  function fillTrend(grid, list) {
    grid.textContent = '';
    list.forEach(function (p, n) {
      var a = el('a', 'ht-sr__card'); a.href = '/products/' + p.handle;
      var im = el('span', 'ht-sr__cimg');
      if (p.img) { var i = document.createElement('img'); i.src = sized(p.img, 260); i.alt = ''; i.width = 130; i.height = 130; i.decoding = 'async'; im.appendChild(i); }
      if (n === 0) im.appendChild(el('em', 'ht-sr__rank', '#1 Best seller'));
      a.appendChild(im); a.appendChild(el('span', 'ht-sr__cname', String(p.title || '').split('|')[0].trim()));
      var pr = el('span', 'ht-sr__cprice'); pr.appendChild(el('b', '', money(p.price)));
      if (Number(p.was) > Number(p.price)) pr.appendChild(el('s', '', money(p.was)));
      a.appendChild(pr); grid.appendChild(a);
    });
  }
  function showLoading() { ensurePanel(); open(); if (!body.firstChild || !model) { body.textContent = ''; body.className = 'ht-sr__body'; body.appendChild(el('p', 'ht-sr__msg', 'Searching…')); items = []; } }

  function productRow(p, isSku) {
    var a = el('a', 'ht-sr__item'); a.href = productUrl(p);
    var th = el('span', 'ht-sr__thumb'); var src = p.featured_image && p.featured_image.url || p.image;
    if (src) { var img = document.createElement('img'); img.src = sized(src, 120); img.alt = ''; img.width = 56; img.height = 56; img.decoding = 'async'; th.appendChild(img); }
    var tx = el('span', 'ht-sr__txt'); var parts = String(p.title || '').split('|'); var name = parts[0].trim(), rest = parts.slice(1).join('|').replace(/\[.*?\]/g, '').trim();
    tx.appendChild(el('span', 'ht-sr__name', name)); if (rest) tx.appendChild(el('span', 'ht-sr__sub', rest));
    var meta = el('span', 'ht-sr__meta'); meta.appendChild(el('b', '', money(p.price)));
    if (Number(p.compare_at_price_max) > Number(p.price)) meta.appendChild(el('s', '', money(p.compare_at_price_max)));
    if (isSku) meta.appendChild(el('em', 'ht-sr__tag ht-sr__tag--sku', 'SKU match'));
    if (p.available === false) meta.appendChild(el('em', 'ht-sr__tag', 'Sold out'));
    tx.appendChild(meta); a.appendChild(th); a.appendChild(tx); return a;
  }
  function viewAllHref(t, hasSku) { return SEARCH_URL + '?type=product&q=' + enc(hasSku ? '"' + t + '"' : t); }

  function render(m) {
    model = m; body.textContent = ''; body.className = 'ht-sr__body is-results';
    var total = m.sku.length + m.products.length;
    if (!total && !m.collections.length) {
      body.appendChild(el('p', 'ht-sr__msg', 'No results for “' + m.term + '”. Try a shorter word or a SKU.'));
      var all0 = el('a', 'ht-sr__all', 'Search the whole store for “' + m.term + '” →'); all0.href = viewAllHref(m.term, false); body.appendChild(all0);
    } else {
      if (total) {
        var s = el('section', 'ht-sr__sec'); s.appendChild(el('div', 'ht-sr__head', 'Products'));
        var pl = el('div', 'ht-sr__plist');
        m.sku.forEach(function (p) { pl.appendChild(productRow(p, true)); });
        m.products.forEach(function (p) { pl.appendChild(productRow(p, false)); });
        s.appendChild(pl); body.appendChild(s);
      }
      if (m.collections.length) {
        var s2 = el('section', 'ht-sr__sec'); s2.appendChild(el('div', 'ht-sr__head', 'Collections')); var w = el('div', 'ht-sr__chips');
        m.collections.forEach(function (c) { w.appendChild(chip(c.title, c.url.split('?')[0])); }); s2.appendChild(w); body.appendChild(s2);
      }
      var all = el('a', 'ht-sr__all', 'See all results for “' + m.term + '” →'); all.href = viewAllHref(m.term, m.sku.length > 0); body.appendChild(all);
    }
    collect(); announce.textContent = total ? total + ' products found' : 'No products found';
    position();
  }

  /* ---------- searching ---------- */
  function suggest(q, fields, limit, types) {
    return fetch('/search/suggest.json?q=' + enc(q) + '&resources[type]=' + types + '&resources[limit]=' + limit + '&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=' + enc(fields), { signal: ctl.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
      .then(function (d) { return (d && d.resources && d.resources.results) || {}; });
  }
  function run(now) {
    var t = input.value.trim();
    if (t.length < 2) { clearTimeout(timer); if (ctl) ctl.abort(); showIdle(); return; }
    if (t === term && model) { open(); return; }
    clearTimeout(timer);
    timer = setTimeout(function () { go(t); }, now ? 0 : 150);
  }
  function go(t) {
    term = t;
    if (cache[t]) { open(); render(cache[t]); return; }
    if (ctl) ctl.abort(); ctl = ('AbortController' in window) ? new AbortController() : { signal: undefined, abort: function () { } };
    showLoading();
    var cur = ctl; setTimeout(function () { if (ctl === cur && t === term && !cache[t]) { cur.timedOut = true; cur.abort(); } }, 7000);   // a hung request ends as "not available"
    var main = suggest(t, 'title,product_type,variants.sku,variants.title,vendor,tag', 8, 'product,collection');
    var sku = skuLike(t) ? suggest('"' + t + '"', 'variants.sku', 4, 'product') : Promise.resolve({});
    Promise.all([main, sku]).then(function (res) {
      if (t !== term) return;
      var skuP = (res[1].products || []).slice(0, 3);
      var m = { term: t, sku: skuP, products: skuP.length ? [] : (res[0].products || []).slice(0, 7) /* an exact SKU hit shows only that, no look-alikes */, collections: (res[0].collections || []).slice(0, 3) };
      cache[t] = m; open(); render(m);
    }).catch(function (e) { if (e && e.name === 'AbortError' && !cur.timedOut) return; if (t === term) { body.textContent = ''; body.appendChild(el('p', 'ht-sr__msg', 'Search is not available right now.')); var a = el('a', 'ht-sr__all', 'Open the full search page →'); a.href = viewAllHref(t, false); body.appendChild(a); } });
  }

  /* ---------- voice search (browser speech recognition; the mic is only added where the browser supports it) ---------- */
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition, rec = null, mic = null;
  function say(text) {
    if (!input) return;
    ensurePanel(); open(); body.textContent = ''; body.className = 'ht-sr__body'; term = ''; model = null; items = [];
    body.appendChild(el('p', 'ht-sr__msg', text));
  }
  function voice() {
    if (rec) { rec.stop(); return; }
    var i = mic.parentNode.querySelector(SEL); attach(i);
    var heard = false, err = '', r = rec = new SR();
    r.lang = 'en-IN'; r.interimResults = true; r.continuous = false; r.maxAlternatives = 1;
    r.onstart = function () { mic.classList.add('is-listening'); mic.setAttribute('aria-pressed', 'true'); i.value = ''; say('Listening… say a product, colour or SKU'); };
    r.onresult = function (e) {
      var t = ''; for (var k = 0; k < e.results.length; k++) t += e.results[k][0].transcript;
      t = t.replace(/[.,!?]+$/, '').trim(); if (!t) return;
      heard = true; i.value = t; run(!!e.results[e.results.length - 1].isFinal);
    };
    r.onerror = function (e) { err = e.error || ''; };
    r.onend = function () {
      mic.classList.remove('is-listening'); mic.removeAttribute('aria-pressed'); rec = null;
      if (!heard) say(err === 'not-allowed' || err === 'service-not-allowed' ? 'The microphone is blocked. Allow it in the browser settings and try again.' : 'Could not hear anything. Tap the mic and try again.');
    };
    try { r.start(); } catch (e) { rec = null; }
  }
  function addMic() {
    if (!SR) return;
    var f = document.querySelector('.header__inline-search'); if (!f || f.querySelector('.ht-sr__mic')) return;
    mic = el('button', 'ht-sr__mic'); mic.type = 'button'; mic.setAttribute('aria-label', 'Search by voice'); mic.title = 'Search by voice';
    mic.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v4"/></svg>';
    mic.addEventListener('click', voice); f.appendChild(mic);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addMic); else addMic();

  /* ---------- events (delegated, one set for both header boxes) ---------- */
  function attach(i) {
    if (input === i) return;
    input = i; loadCss(); ensurePanel();
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-controls', 'ht-sr'); input.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('focusin', function (e) {
    var i = e.target.closest && e.target.closest(SEL); if (!i) return;
    attach(i); if (i.value.trim().length >= 2) run(true); else showIdle();
  });
  document.addEventListener('input', function (e) { if (e.target === input) run(false); });
  document.addEventListener('keydown', function (e) {
    if (e.target !== input) return;
    if (e.key === 'Escape') { close(); }
    else if (e.key === 'ArrowDown' && panel && !panel.hidden) { e.preventDefault(); setActive(active + 1); }
    else if (e.key === 'ArrowUp' && panel && !panel.hidden) { e.preventDefault(); setActive(active - 1); }
    else if (e.key === 'Enter') {
      var v = input.value.trim(); if (!v) return;
      if (active > -1 && items[active]) { e.preventDefault(); remember(v); location.href = items[active].href; return; }
      var hit = model && model.term === v && model.sku[0];                      // exact SKU: straight to the product
      if (hit) { e.preventDefault(); remember(v); location.href = productUrl(hit); return; }
      remember(v);
      if (skuLike(v) && model && model.term === v && model.sku.length) { e.preventDefault(); location.href = viewAllHref(v, true); }
    }
  });
  document.addEventListener('pointerdown', function (e) { if (!panel || panel.hidden) return; if (e.target === input || panel.contains(e.target)) return; close(); }, true);
  window.addEventListener('resize', function () { if (panel && !panel.hidden) position(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(); });
})();
